<script lang="ts">
    import type { ProjectData } from "../../api/projects/data/projects/ProjectData";
    import { appManager } from "../../AppManager";
    export let projectData: ProjectData;
</script>

<a href={`${appManager.RootUrl}settings/organizations/${projectData?.organization?.id ?? ""}`}>{projectData?.organization?.name ?? ""}</a>